module.exports = __webpack_public_path__ + "static/media/code.d7f7e9ac.svg";